import React, { useCallback, useEffect, useState } from 'react';
import { getMarkets, IMarket } from '@ui/api/v2/markets.api';
import { Page, PageNavigation } from '@ui/components';
import MarketCard from './MarketCard';

import './Markets.less';
import MarketForm from './MarketForm';

export function Markets() {
  const [markets, setMarkets] = useState<IMarket[]>([]);

  const [editMarket, setEditMarket] = useState<IMarket>();

  const fetchMarkets = useCallback(async () => {
    const { data } = await getMarkets();
    if (data) {
      setMarkets(data);
    }
  }, []);
  useEffect(() => {
    void fetchMarkets();
  }, [fetchMarkets]);

  const resetEditMarket = useCallback(() => {
    setEditMarket(undefined);
  }, []);

  const onMarketCreate = useCallback((market: IMarket) => {
    setMarkets(m => [...m, market]);
  }, []);

  const onMarketUpdate = useCallback((market: IMarket) => {
    setMarkets(markets =>
      markets.map(m => {
        if (m.id === market.id) {
          return market;
        }
        return m;
      }),
    );
  }, []);

  const onMarketDelete = useCallback((marketId: number) => {
    setMarkets(markets => markets.filter(m => m.id !== marketId));
  }, []);

  return (
    <div className="markets">
      <PageNavigation title="ТЦ" />
      <Page>
        <Page.LeftSide>
          <MarketForm
            market={editMarket}
            onMarketCreate={onMarketCreate}
            onMarketUpdate={onMarketUpdate}
            resetEditMarket={resetEditMarket}
          />
        </Page.LeftSide>
        <Page.Content>
          <div className="markets__wrapper">
            {[...markets]
              .sort((a, b) => (a.name < b.name ? -1 : 1))
              .map(m => (
                <MarketCard
                  key={m.id}
                  market={m}
                  setEditMarket={setEditMarket}
                  onDelete={onMarketDelete}
                />
              ))}
          </div>
        </Page.Content>
      </Page>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/Markets/Markets.tsx